import "./namespace.js";
import "#/legacy/namespaces.js";

DoctorFinder.Helpers.validate = (obj, ...propList) => {
  propList.forEach((prop) => {
    if (!(prop in obj)) {
      const msg = `${JSON.stringify(prop)} is required`;
      console.error(msg, obj);
      throw new Error(msg);
    }
  });
  return obj;
};

// Takes a the value of the DoctorFinder's filters option and a filter name
// Returns true if the filter should be enabled
// Returns false if it should not be
DoctorFinder.Helpers.isFilterEnabled = (filtersOption, filterName) => {
  if (filtersOption === false) {
    // Legacy for hardcoded DFs
    return false;
  } else if (_.isArray(filtersOption) && !Array.from(filtersOption).includes(filterName)) {
    return false;
  } else {
    return true;
  }
};

// Entry links plant scoping params the results page renders no control for — e.g. a
// location page's "who works here" search links to the finder with `location` +
// `specialty_scope`. Once the user changes the corresponding user-facing filter, the
// entry scope no longer reflects their intent, but with no control to clear it, it
// silently ANDs with the new value and over-constrains the search to zero results
// (https://github.com/combinaut/sparkle-christus/issues/303).
//
// Takes a partial filter update, the currently applied filters, and a map of
// { <user-facing filter>: <entry scope it supersedes> }. Clears each superseded scope
// whose superseding filter the update changes — returning a copy of the update when
// anything is cleared, or the update as passed in (same object, untouched) otherwise.
// An update that explicitly sets a scope itself always wins over the clearing.
DoctorFinder.Helpers.clearSupersededEntryScopes = (filters, currentFilters, scopeMap) => {
  if (!filters) {
    return filters;
  }

  let cleared = filters;
  for (const [filterName, scopeName] of Object.entries(scopeMap)) {
    if (!(filterName in filters)) {
      continue;
    }
    if (scopeName in filters) {
      continue; // the update explicitly manages the scope itself
    }
    if (String(filters[filterName] ?? "") === String((currentFilters ?? {})[filterName] ?? "")) {
      continue; // superseding filter unchanged
    }

    if (cleared === filters) {
      cleared = Object.assign({}, filters); // Don't modify the filters passed in
    }
    cleared[scopeName] = "";
  }

  return cleared;
};
